import { VersicherungsangabenSectionConfig } from '@/features/Versicherungsangaben/types';
import { SECTION } from '@/components/layout/types';

export const contractVersicherungsangabenSectionConfig: VersicherungsangabenSectionConfig =
  {
    [SECTION.CONTRACT_COMPANY_CLIENT]: {
      label: 'Angaben zum Versicherungsnehmer (Firma)',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/kfz/contract/ContractCompanyClient.vue'
        ),
      componentProps: {
        label: 'Angaben zum Versicherungsnehmer',
      },
    },
    [SECTION.CONTRACT_CLIENT]: {
      label: 'Angaben zum Versicherungsnehmer (Privat)',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
        ),
    },
    [SECTION.KFZ_CONTRACT_ABWEICHENDERHALTER]: {
      label: 'Angaben zum abweichenden Halter',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/kfz/contract/ContractAbweichenderHalter.vue'
        ),
    },
    [SECTION.KFZ_CONTRACT_FAHRERKREIS]: {
      label: 'Fahrerkreis',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/kfz/contract/ContractFahrerkreis.vue'
        ),
    },
    [SECTION.KFZ_CONTRACT_CAR]: {
      label: 'Fahrzeugdaten',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/kfz/contract/ContractCarData.vue'
        ),
    },
    [SECTION.KFZ_CONTRACT_CAR_EXTENDED]: {
      label: 'Erweiterte Fahrzeugdaten',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/kfz/contract/ContractCarDataExtended.vue'
        ),
    },
    [SECTION.KFZ_EVB]: {
      label: 'Angaben zur Versicherungsbestätigung (eVB)',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/kfz/contract/ContractEVBInput.vue'
        ),
    },
    [SECTION.KFZ_PREVIOUS_INSURANCE]: {
      label: 'Angaben zur Vorversicherung',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/kfz/contract/ContractPreviousInsurance.vue'
        ),
    },
    [SECTION.CONTRACT_BANK_TRANSFER_INFORMATION]: {
      label: 'Zahlungsinformation',
      requiresContractTariff: true,
      component: () =>
        import(
          '@/features/Sparten/shared/sections/property/contract/ContractBankTransferInformation.vue'
        ),
      slots: {
        bankPaymentMethodSection: () =>
          import(
            '@/features/Sparten/shared/sections/kfz/contract/ContractPaymentMethod.vue'
          ),
      },
    },
  };
